import axios from 'lib/axios'

export const getModelDetails = async (modelId: number) => {
  const url = `${process.env.REACT_APP_MAIN_API}/companies/models/details/${modelId}`

  try {
    const response = await axios.get(url)
    return response.data
  } catch (error) {
    console.error(error)
  }
}
